import { TranslatePipe } from '../../../filters/translate.pipe';
import { PreVisitFeedbackComponentComponent } from '../../../components/pre-visit/feedback/pre-visit-feedback.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Session from '../../../utils/session.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'pre-visit-thank-you',
	templateUrl: './pre-visit-thank-you.component.html',
	imports: [ CommonModule, TranslatePipe, PreVisitFeedbackComponentComponent, FormsModule, RouterLink ]
})
export class PreVisitThankYouComponentComponent implements OnInit {
	private session: Session = inject(Session);
	
	@Input() isRecordTicketForPerson: any | undefined;
	@Input() preVisitTicketId: any | undefined;
	@Input() isInitialized: any | undefined;
	@Input() informationSection: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
		
		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.iconSuffix = '-previsit';
		} else {
			this.vm.iconSuffix = '';
		}
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
	}
	
}